/**
 * Determines the attachment type based on MIME type.
 *
 * @param mimeType - The MIME type of the file (e.g., "image/png", "video/mp4", "application/pdf")
 * @returns The attachment type: "image", "video", or "file"
 *
 * @example
 * getAttachmentType("image/png") // "image"
 * getAttachmentType("video/mp4") // "video"
 * getAttachmentType("application/pdf") // "file"
 */
export const getAttachmentType = (mimeType: string): "image" | "video" | "file" => {
  if (mimeType.startsWith("image/")) return "image";
  if (mimeType.startsWith("video/")) return "video";
  return "file";
};
